import * as z from "zod";

// Referrer branding attributed to the current team, for the "free with
// {referrer}, already applied" chargebacks onboarding treatment.
export const getTeamReferralAttribution = {
  name: "getTeamReferralAttribution" as const,
  input: z.object({}),
  output: z
    .object({
      referrerName: z.string().max(256),
      logoUrl: z.string().max(2048).nullable(),
    })
    .nullable(),
};
